/* Harten & Row — modular storefront interactions */
(() => {
  'use strict';
  const cfg = window.HRTheme || { routes: { cart: '/cart', cartAdd: '/cart/add', root: '/' }, currency: 'USD' };
  const money = (value) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cfg.currency || 'USD' }).format((Number(value) || 0) / 100); }
    catch (_) { return '$' + ((Number(value) || 0) / 100).toFixed(2); }
  };
  const matchVariant = (variants, values) => {
    if (!Array.isArray(variants)) return null;
    return variants.find(v => Array.isArray(v.options) && v.options.length === values.length && v.options.every((opt, idx) => String(opt) === String(values[idx]))) || null;
  };
  const setupHeader = () => {
    const header = document.querySelector('#HRHeader');
    if (!header || header.dataset.hrReady) return;
    header.dataset.hrReady = 'yes';
    const menuButton = header.querySelector('[data-menu-toggle]');
    const searchButton = header.querySelector('[data-search-toggle]');
    const menu = header.querySelector('#HRMobileMenu');
    const search = header.querySelector('#HRSearch');
    const toggle = (button, panel, otherButton, otherPanel) => {
      if (!button || !panel) return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (otherButton && otherPanel) { otherButton.setAttribute('aria-expanded', 'false'); otherPanel.hidden = true; }
      button.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      if (!expanded && panel === search) panel.querySelector('input')?.focus();
    };
    menuButton?.addEventListener('click', () => toggle(menuButton, menu, searchButton, search));
    searchButton?.addEventListener('click', () => toggle(searchButton, search, menuButton, menu));
    document.addEventListener('keydown', ev => {
      if (ev.key === 'Escape') { if (menu) menu.hidden = true; if (search) search.hidden = true; menuButton?.setAttribute('aria-expanded', 'false'); searchButton?.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('click', ev => {
      if (!header.contains(ev.target)) { if (menu) menu.hidden = true; if (search) search.hidden = true; menuButton?.setAttribute('aria-expanded', 'false'); searchButton?.setAttribute('aria-expanded', 'false'); }
    });
  };
  const setupProduct = (root) => {
    if (root.dataset.hrReady) return;
    root.dataset.hrReady = 'yes';
    const form = root.querySelector('.hr-product-form');
    if (!form) return;
    const data = root.querySelector('[data-product-variants]');
    let variants = [];
    try { variants = JSON.parse(data?.textContent || '[]'); } catch (_) {}
    const choices = [...root.querySelectorAll('[data-product-option]')];
    const hiddenId = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const submit = root.querySelector('[data-product-submit]');
    const submitLabel = root.querySelector('[data-product-submit-label]');
    const formStatus = root.querySelector('[data-product-form-status]');
    function update() {
      const selected = matchVariant(variants, choices.map(el => el.value)) || (choices.length === 0 ? variants.find(v => v.available) || variants[0] : null);
      if (selected && hiddenId) hiddenId.value = selected.id;
      else if (hiddenId) hiddenId.value = '';
      if (selected && price) price.textContent = money(selected.price);
      if (compare) {
        compare.hidden = !selected || !(selected.compare_at_price > selected.price);
        if (selected?.compare_at_price > selected?.price) compare.textContent = money(selected.compare_at_price);
      }
      if (submit && submitLabel) {
        submit.disabled = !selected || !selected.available;
        submitLabel.textContent = !selected ? 'UNAVAILABLE' : selected.available ? 'ADD TO BAG' : 'SOLD OUT';
      }
      if (selected && window.history && history.replaceState) {
        try { const url = new URL(window.location.href); url.searchParams.set('variant', selected.id); window.history.replaceState(history.state, '', url.toString()); } catch (_) { /* Native product form still works. */ }
      }
      for (const choice of choices) {
        const current = choice.closest('.hr-product-option')?.querySelector('[data-selected-option]');
        if (current) current.textContent = choice.value;
      }
    }
    choices.forEach(el => el.addEventListener('change', () => { if (formStatus) formStatus.textContent = ''; update(); }));
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { const q = root.querySelector('input[name=quantity]'); if (q) q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { const q = root.querySelector('input[name=quantity]'); if (q) q.value = (parseInt(q.value, 10) || 0) + 1; });
    const main = root.querySelector('.hr-product-gallery__primary');
    root.querySelectorAll('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
      if (main && btn.dataset.imageUrl) { main.src = btn.dataset.imageUrl; main.alt = btn.dataset.imageAlt || ''; main.removeAttribute('srcset'); }
      root.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));
    update();
  };
  const setupLook = (root) => {
    if (root.dataset.hrReady) return;
    root.dataset.hrReady = 'yes';
    const items = [...root.querySelectorAll('[data-look-item]')];
    const button = root.querySelector('[data-add-look]');
    const idleButtonContent = button ? [...button.childNodes].map(node => node.cloneNode(true)) : [];
    const message = root.querySelector('[data-look-message]');
    const total = root.querySelector('[data-look-total]');
    const selections = () => items.map(item => {
      let variants = [];
      try { variants = JSON.parse(item.querySelector('[data-look-variants]')?.textContent || '[]'); } catch (_) {}
      const dropdowns = [...item.querySelectorAll('[data-look-option]')];
      const hidden = item.querySelector('[data-look-variant]');
      if (dropdowns.length === 0) return variants.find(v => String(v.id) === String(hidden?.value)) || variants[0] || null;
      return matchVariant(variants, dropdowns.map(s => s.value));
    });
    const update = () => {
      const vs = selections();
      const allValid = vs.length > 0 && vs.every(v => v && v.available);
      if (total) total.textContent = money(vs.reduce((n, v) => n + (v?.price || 0), 0));
      if (button) button.disabled = !allValid;
      if (message) message.textContent = allValid ? '' : 'One or more selections are unavailable. Please choose different sizes.';
    };
    items.forEach(item => item.querySelectorAll('[data-look-option]').forEach(el => el.addEventListener('change', update)));
    update();
    button?.addEventListener('click', async () => {
      const vs = selections();
      if (!vs.length || vs.some(v => !v || !v.available)) { update(); return; }
      button.disabled = true;
      button.textContent = 'ADDING TO BAG…';
      if (message) message.textContent = '';
      try {
        const response = await fetch((cfg.routes.cartAdd || '/cart/add').replace(/\/$/, '') + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: vs.map(v => ({ id: Number(v.id), quantity: 1 })) })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this look.');
        window.location.assign(cfg.routes.cart || '/cart');
      } catch (error) {
        if (message) message.textContent = error.message || 'We could not add the look. Please try again.';
        button.replaceChildren(...idleButtonContent.map(node => node.cloneNode(true)));
        update();
      }
    });
  };
  const init = (scope = document) => {
    setupHeader();
    scope.querySelectorAll?.('[data-product-section]').forEach(setupProduct);
    scope.querySelectorAll?.('[data-look-builder]').forEach(setupLook);
    scope.querySelectorAll?.('[data-auto-submit]').forEach(el => { if (el.dataset.hrReady) return; el.dataset.hrReady = 'yes'; el.addEventListener('change', () => el.form?.requestSubmit()); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', ev => init(ev.target));
})();
